/* eslint-disable react/no-danger */
import React, { Fragment, useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigateParaHome } from '../../../../../utils/rotas/navigate'
import { BOTAO_IR_PARA_HOME } from '../constantsCancelarAssinatura'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import Loader from '@taglivros/oef_componentes/build/components/loader'
import { useSolicitacaoCancelamento } from '../../../../../contexts/SolicitacaoCancelamentoContext'
import { TITULO_ASSINATURA_SUSPENSA, getTextoConlusaoSuspensao } from './constantsConclusaoSuspensao'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import Navegacao from '../components/Navegacao/Navegacao'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../../utils/helpers/helpersAssinatura'

const Container = styled.div`
  max-width: 80%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }

  h4 {
    margin: 0 0 15px;
    color: ${StyleGuide.cores.cinza500}
    ${StyleGuide.boldFonte}
  }

  p {
    margin: 2px 0;

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-bottom: 20px;
    }
  }
`

const LoaderWrapper = styled.div`
  padding: 100px 0;
`

const ConclusaoSuspensao = () => {
  const { dadosGlobaisAssociado, getDadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const [ textoSuspensao, setTextoSuspensao ] = useState()
  const [ plano, setPlano ] = useState()
  const { dadosKitsCobrancas } = useSolicitacaoCancelamento()

  const handleFinalizar = () => {
    getDadosGlobaisAssociado()
    navigateParaHome()
  }

  useEffect( () => {
    if ( dadosKitsCobrancas && plano ) {
      setTextoSuspensao( getTextoConlusaoSuspensao( dadosKitsCobrancas, plano ) )
    }
  }, [ dadosKitsCobrancas, plano ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setPlano( assinaturaObtida.plano )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  const htmlText = { '__html': textoSuspensao }

  return (
    <div>
      <Card
        className="card"
        largura="100%"
      >
        { textoSuspensao ?
          <Fragment>
            <Container>
              <h4> { TITULO_ASSINATURA_SUSPENSA } </h4>
              <p dangerouslySetInnerHTML={ htmlText } />
            </Container>
            <Navegacao
              eventoBotaoContinuar={ handleFinalizar }
              tituloContinuar={ BOTAO_IR_PARA_HOME }
            />
          </Fragment> :
          <LoaderWrapper>
            <Loader isCenter />
          </LoaderWrapper>}
      </Card>
    </div>
  )
}

export default ConclusaoSuspensao

